const SELECTORS = Selectors({
  lazy: '[data-lazy]'
})

const props = {
  $lazy: document.querySelectorAll(SELECTORS.lazy),
  lazyLoadLoaded: null,
  instance: null
}

const fn = {
  init: () => {
    props.lazyLoadLoaded = setInterval(fn.bindEvents, 16)
  },

  bindEvents: () => {
    if (!window.LazyLoad) {
      return
    }

    clearInterval(props.lazyLoadLoaded)

    props.instance = new LazyLoad({
      elements_selector: SELECTORS.lazy
    })
  },

  update: () => {
    if (props.instance) {
      props.instance.update()
    }
  }
}

export const Lazy = {
  update: fn.update
}

export default {
  can: () => props.$lazy.length,
  run: fn.init
}
